
import { useState, useCallback, useRef } from 'react';

interface UseQrScannerStateProps {
  onQrScan: (data: string) => void;
  onRefreshData?: () => void;
}

export const useQrScannerState = ({ onQrScan, onRefreshData }: UseQrScannerStateProps) => {
  const [showCamera, setShowCamera] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [cameraKey, setCameraKey] = useState<number>(0);
  
  const handleRefreshData = useCallback(() => {
    if (!onRefreshData || isRefreshing) return;
    
    setIsRefreshing(true);
    onRefreshData();
    
    setTimeout(() => {
      setIsRefreshing(false);
    }, 2000);
  }, [onRefreshData, isRefreshing]);
  
  const openCamera = useCallback(() => {
    console.log('Opening camera scanner');
    setCameraKey(prevKey => prevKey + 1);
    setShowCamera(true);
  }, []);
  
  const handleQrScan = useCallback((data: string) => {
    console.log('QR code detected in scanner:', data);
    // Pass the data directly to the onQrScan handler
    onQrScan(data);
  }, [onQrScan]);
  
  const closeCamera = useCallback(() => {
    console.log("Closing camera scanner");
    setShowCamera(false);
  }, []);
  
  // This function is exposed to parent components via direct ref
  const openCameraExternally = useCallback(() => {
    console.log("openCameraExternally called");
    openCamera();
  }, [openCamera]);

  return {
    showCamera,
    isRefreshing,
    cameraKey,
    handleRefreshData,
    openCamera,
    handleQrScan,
    closeCamera,
    openCameraExternally
  };
};
